export enum RemoteNamespace {
  Log = 'log-diag',
  Metrics = 'metrics-advisor',
  MetricsCompare = 'metrics-compare'
}
